import React from "react";

export default function ModalPopupComponent({
  isPopup = false,
  onClosePopup = () => {},
  onBackPopup = null,
  showBackButton = false,
  showCrossButton = true,
  outSideClickBool = true,
  onOutSideClick = () => {},
  modalCss = {},
  backIcon = "/images/back-left-arrow.svg",
  closeIcon = "/images/cross_black.svg",
  children,
  isMobile,
}) {
  const styles = {
    modal_container: "",
    modal_background: "",
    modal_content: "",
    modal_back: "",
    modal_close: "",
    close_icon: "",
    ...modalCss,
  };

  if (!isPopup) return null;

  return (
    <>
      <div
        className={`${styles.modal_background} modal-background`}
        onClick={() => {
          if (outSideClickBool) {
            onOutSideClick(false);
          }
        }}
      ></div>

      <div className={`${styles.modal_container} modal-container`}>
        <div className={`${styles.modal_content} modal-content`}>
          {showBackButton && (
            <div
              onClick={onBackPopup}
              className={`${styles.modal_back} modal-back`}
            >
              <img src={backIcon} alt="Back" className={styles.close_icon} />
            </div>
          )}

          {showCrossButton && (
            <div
              onClick={() => onClosePopup(false)}
              className={`${styles.modal_close} modal-close`}
            >
              <img src={closeIcon} alt="Close" className={styles.close_icon} />
            </div>
          )}

          {children}
        </div>
      </div>
    </>
  );
}
